var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmploymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8105 7.85862V7.14041C10.8105 5.55138 10.8105 4.26758 14.8804 4.26758H16.9153C20.9852 4.26758 20.9852 5.55138 20.9852 7.14041V7.85862",
    fill: "#E0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7951 17.4333V18.6304C16.7951 18.6423 16.7951 18.6423 16.7951 18.6543C16.7951 19.959 16.7862 21.0244 14.9996 21.0244C13.2221 21.0244 13.2041 19.971 13.2041 18.6663V17.4333C13.2041 16.2363 13.2041 16.2363 14.1019 16.2363H15.8974C16.7951 16.2363 16.7951 16.2363 16.7951 17.4333Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 29.3333H21.3334C26.6934 29.3333 27.6534 27.1867 27.9334 24.5733L28.9334 13.9067C29.2934 10.6533 28.3601 8 22.6668 8H9.33343C3.6401 8 2.70676 10.6533 3.06676 13.9067L4.06676 24.5733C4.34676 27.1867 5.30676 29.3333 10.6668 29.3333Z",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8105 7.85837V6.90076C10.8105 4.78204 10.8105 3.07031 14.8804 3.07031H16.9153C20.9852 3.07031 20.9852 4.78204 20.9852 6.90076V7.85837",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 17.3333V18.6667C18.6663 18.68 18.6663 18.68 18.6663 18.6933C18.6663 20.1467 18.653 21.3333 15.9997 21.3333C13.3597 21.3333 13.333 20.16 13.333 18.7067V17.3333C13.333 16 13.333 16 14.6663 16H17.333C18.6663 16 18.6663 16 18.6663 17.3333Z",
    stroke: "#081E54",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.867 14.666C25.787 16.906 22.267 18.2393 18.667 18.6927",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49316 15.0254C6.49316 17.0787 9.87983 18.3187 13.3332 18.7054",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentIcon);
export default __webpack_public_path__ + "static/media/EmploymentIcon.99bb80774000c9bf981580a257ce23f7.svg";
export { ForwardRef as ReactComponent };